import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

const TONES = {
	neutral: 'text-bgBase-800 hover:bg-bgBase-400 hover:text-text',
	primary: 'text-bgBase-800 hover:bg-primary-100 hover:text-primary-600',
	danger: 'text-bgBase-800 hover:bg-warning-200 hover:text-warning-700',
};

const IconButton = ({ icon: Icon, label, tone = 'neutral', className, type = 'button', ...props }) => (
	<button
		type={type}
		title={label}
		aria-label={label}
		className={twMerge(
			`inline-flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-control transition-colors focus:outline-none focus:ring-2 focus:ring-primary-300 disabled:pointer-events-none disabled:opacity-50 ${TONES[tone]}`,
			className,
		)}
		{...props}
	>
		<Icon className="h-4 w-4" />
	</button>
);

IconButton.propTypes = {
	icon: PropTypes.elementType.isRequired,
	label: PropTypes.string.isRequired,
	tone: PropTypes.oneOf(Object.keys(TONES)),
	onClick: PropTypes.func,
	disabled: PropTypes.bool,
	className: PropTypes.string,
	type: PropTypes.oneOf(['button', 'submit']),
};

export default IconButton;
